<div class="relative">
  <div [id]="'bazaarvoice-inline-rating-' + productId" data-bv-seo="false" data-bv-show="inline_rating"></div>
</div>
